export default "__VITE_ASSET__DWHfH5eo__"